import { MatSnackBar } from '@angular/material/snack-bar';
import { HttpService } from './../../services/http/http.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from "@angular/material/table";
import { MatPaginator } from "@angular/material/paginator";
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from "@angular/material/dialog";

@Component({
  selector: 'app-accountsetting',
  templateUrl: './accountsetting.component.html',
  styleUrls: ['./accountsetting.component.scss']
})
export class AccountsettingComponent implements OnInit {

  constructor(public dialog: MatDialog, private httpSv: HttpService , private _snackBar: MatSnackBar) { }
  @ViewChild("paginator", { read: MatPaginator }) paginator: MatPaginator;
  ngOnInit(): void {
    this.getResturantFunc()
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  restoSelectedCondition = true
  superSelectedCondition = false
  restaurantList: any[] = [];
  noResto:number;
  searchText:string;
  dataSource: MatTableDataSource<[]> = new MatTableDataSource(this.restaurantList)
  displayedColumns: string[] = ["SI-NO", "name", "edit", "email","action"];




  restoSelectFunc() {
    this.getResturantFunc()
    this.restoSelectedCondition = true
    this.superSelectedCondition = false
  }
  superSelectFunc() {
    this.restoSelectedCondition = false
    this.superSelectedCondition = true
  }
  filter() {
    if (this.searchText == "") {
      this.dataSource = new MatTableDataSource(this.restaurantList);
      this.dataSource.paginator = this.paginator;
    } else {
      let temp = this.restaurantList.filter((ele: any) => {
        return ele.name
          .toLocaleLowerCase()
          .match(this.searchText.toLocaleLowerCase());
      });
      this.dataSource = new MatTableDataSource(temp);

      if (temp.length === 0) {
        let temp = this.restaurantList.filter((ele: any) => {
          return ele.unique_id
            .toLocaleLowerCase()
            .match(this.searchText.toLocaleLowerCase());
        });
        this.dataSource = new MatTableDataSource(temp);
      }
      this.dataSource.paginator = this.paginator;
    }
  }
  editRestPassword(id) {
    const dialogRef = this.dialog.open(UpdateRestoPassword)
    dialogRef.afterClosed().subscribe(result => {
      if(result == false || result == undefined){
      }else{
        const data = new FormData()
        data.append('restaurant_id',id)
        data.append('password',result)
        this.httpSv.changeRestaurantPassword(data).subscribe(res =>{
          if(res['status']== true){
            this._snackBar.open('Password Updated Successfully')
            setTimeout(()=>{
              this._snackBar.dismiss()
            },2000)
          }else{
            this._snackBar.open(res['message'])
            setTimeout(()=>{
              this._snackBar.dismiss()
            })
          }
        }, (err:any)=>{
          this._snackBar.open('Something went wrong')
          setTimeout(()=>{
            this._snackBar.dismiss()
          })
        })
      }
    })
  }
  getResturantFunc() {
    this.httpSv.getRestoAccount().subscribe(res => {
      if (res['status'] == 'TRUE') {
        this.restaurantList = res["result"].data;
        this.dataSource.data = res["result"].data;
        this.dataSource.paginator = this.paginator;
        this.noResto = res["result"].data.length;
      }
    })
  }
}

@Component({
  selector: 'super-acountsetting',
  templateUrl: './super-setting.html',
  styleUrls: ['./accountsetting.component.scss']
})
export class SuperAccountSettingComponent implements OnInit {
  constructor(private httpSv : HttpService, private _snackBar: MatSnackBar) { }
  ngOnInit(): void {
    this.getAdminInfo()
  }
  id:any
  superAdminName:string
  superAdminEmail:string
  validCheckFlag =false
  requiredMiss =false
  oldPassword:string=''
  newPassword:string=''
  confirmPassword:string=''
  src: any = "../../../assets/images/Ellipse 11.png";
  sendData = new FormData()
  onImageChange(event: any) {
    this.sendData.append("file", event.target.files[0]);
    let file: File = event.target.files[0];
    let reader: FileReader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    // console.log(reader);
    reader.onload = (e: any) => {
      this.src = e.target.result;
    };
  }
  inputClick(){
    this.validCheckFlag =false
    this.requiredMiss =false
  }
  updateInfo(){
    this.sendData.append('id',this.id)
    this.sendData.append('first_name', this.superAdminName)
    this.httpSv.updateAdminInfo(this.sendData).subscribe(res=>{
      if(res['status']== 'TRUE'){
        this._snackBar.open('Profile is updated')
        this.getAdminInfo()
        setTimeout(()=>{
          this._snackBar.dismiss()
        },2000)
      }else{
        this._snackBar.open(res['message'])
        setTimeout(()=>{
          this._snackBar.dismiss()
        },2000)
      }
    },err =>{
      this._snackBar.open('Oops! Something went wrong')
      setTimeout(()=>{
        this._snackBar.dismiss()
      },2000)
    })
  }
  updatePasswordAdmin(){
    if(this.newPassword != this.confirmPassword){
      this.validCheckFlag =true
    }
    else if( this.newPassword == "" || this.oldPassword==''){
      this.requiredMiss =true
    }
    else{
      const data = new FormData()
      data.append('id', this.id)
      data.append('old_password',this.oldPassword)
      data.append('password', this.newPassword)
      this.httpSv.updateAdminPassword(data).subscribe(res => {
        if(res['status']=='TRUE'){
          this.oldPassword = ''
          this.newPassword = ''
          this.confirmPassword = ''
          this._snackBar.open('Password is updated')
          setTimeout(()=>{
            this._snackBar.dismiss()
          },2000)
          
        }
        else{
          this._snackBar.open(res['message'])
          setTimeout(()=>{
            this._snackBar.dismiss()
          },2000)
        }
      },err => {
        this._snackBar.open('Opps! Something went wrong')
          setTimeout(()=>{
            this._snackBar.dismiss()
          },2000)
      })
    }
  }
  getAdminInfo(){
    this.httpSv.getAdminInformation().subscribe(res=>{
      if(res['status']=='TRUE'){
        let temp = res['result'].data[0]
        this.src = temp.profile_image
        this.superAdminName = temp.f_name
        this.superAdminEmail = temp.email
        this.id = temp.id

      }
    })
  }

}
@Component({
  selector: "update-resto-password",
  templateUrl: "./resto-password-dialog.html",
})
export class UpdateRestoPassword implements OnInit {
  constructor(private dialogRef: MatDialogRef<UpdateRestoPassword>) { }
  ngOnInit(): void {

  }
  requireMiss = false
  notValidFalg = false
  password:string='';
  confirmPassword:string='';
  changeHandeler(){
    this.notValidFalg = false
    this.requireMiss = false
  }
  close(){
    this.dialogRef.close(false)
  }
  updatePass(){
    if(this.password != this.confirmPassword){
      this.notValidFalg = true
    }
    else if(this.password == ''){
      this.requireMiss = true
    }else{
      this.dialogRef.close(this.password)
    }
  }
}